import { safeJsonResponse } from "@utils/safeJsonResponse";

export async function sendApiRequest<T>(
  url: `/${string}`,
  body?: object
): Promise<T> {
  const res = await fetch(`/api${url}`, {
    method: body ? "POST" : "GET",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  // QC-016: guard against empty/invalid response bodies instead of letting
  // res.json() throw `Unexpected end of JSON input`.
  const jsonResponse = await safeJsonResponse<T>(res);

  return jsonResponse as T;
}
